/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Reveal_Acknowledge2Inputs */

const en_settings_reportingapikeys_reveal_acknowledge2 = /** @type {(inputs: Settings_Reportingapikeys_Reveal_Acknowledge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I have stored/shared this key securely`)
};

/**
* | output |
* | --- |
* | "I have stored/shared this key securely" |
*
* @param {Settings_Reportingapikeys_Reveal_Acknowledge2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_reveal_acknowledge2 = /** @type {((inputs?: Settings_Reportingapikeys_Reveal_Acknowledge2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Reveal_Acknowledge2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_reveal_acknowledge2(inputs)
});
export { settings_reportingapikeys_reveal_acknowledge2 as "settings_reportingApiKeys_reveal_acknowledge" }